/** Fields owned by Quick Estimate. Identity, lifecycle and other project data stay in Firestore. */
export const QUICK_PROJECT_UPDATE_FIELDS = [
  'trade', 'details', 'laborItems', 'totalBaseCost', 'totalDiscountedCost',
  'laborCost', 'totalNetto', 'totalBrutto', 'area', 'estimatedAreaM2',
  'vatRate', 'settlementMode', 'quickEstimateSnapshot',
] as const;

export type QuickProjectUpdate<T> = Pick<T, Extract<keyof T, typeof QUICK_PROJECT_UPDATE_FIELDS[number]>>;

export function buildQuickProjectUpdate<T extends object>(project: T): QuickProjectUpdate<T> {
  return Object.fromEntries(
    QUICK_PROJECT_UPDATE_FIELDS
      .filter((key) => key in project && project[key as keyof T] !== undefined)
      .map((key) => [key, project[key as keyof T]])
  ) as QuickProjectUpdate<T>;
}
